'use strict';

export default class DefaultGenerator {
	_filename_default = '';
	_mimeType = '';
	_content = '';
	_filename = '';
	_extension = '';
	_data;
	_parsed_content;

	constructor(filename) {
		this._filename_default = filename;
	}

	generate(data, content) {
		this._data = data;
		this._content = content
		return content;
	}

	parse(parsedContent) {
		return this._parsed_content = parsedContent;
	}

	setFileName(filename) {
		this._filename_default = filename
	}

	download() {
		const blob = new Blob([this._content], { type: this._mimeType });
		const link = document.createElement('a');
		link.href = URL.createObjectURL(blob);
		link.download = this._filename.trim() + '.' + this._extension;
		link.click();
	}

	log() {
		if (typeof this._data === 'object') {
			console.table(this._data);
		} else {
			console.log(this._data);
		}
	}
}
